import * as React from "react";
import { forwardRef } from "react";
const SvgMusic = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-music-icon lucide-music", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 18V5l12-2v13" }), /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 18, r: 3 }), /* @__PURE__ */ React.createElement("circle", { cx: 18, cy: 16, r: 3 }));
const ForwardRef = forwardRef(SvgMusic);
export default ForwardRef;
